"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TradeCallParameters = void 0;
/**
 * Represents the parameters required to make a trade call.
 */
class TradeCallParameters {
    /**
     * Constructs an instance of TradeCallParameters.
     * @param methodName The name of the method to be called.
     * @param args The arguments to be passed to the method.
     * @param value The value to be transferred with the call.
     * @param rawTxn The raw transaction data.
     */
    constructor({ methodName, args, value, rawTxn }) {
        this._methodName = methodName;
        this._args = args;
        this._value = value;
        this._rawTxn = rawTxn;
    }
    /**
     * Gets the method name.
     * @returns The name of the method to be called.
     */
    get methodName() {
        return this._methodName;
    }
    /**
     * Gets the arguments of the method.
     * @returns The arguments to be passed to the method.
     */
    get args() {
        return this._args;
    }
    /**
     * Gets the value to be transferred with the call.
     * @returns The value as a string.
     */
    get value() {
        return this._value;
    }
    /**
     * Gets the raw transaction data.
     * @returns The raw transaction data as a record.
     */
    get rawTxn() {
        return this._rawTxn;
    }
    /**
     * Creates an instance of TradeCallParameters from a JSON object.
     * @param json The JSON object containing the parameters.
     * @returns A new instance of TradeCallParameters populated with the JSON object's values.
     */
    static fromJson(json) {
        return new TradeCallParameters({
            methodName: json.methodName,
            args: json.args,
            value: json.value,
            rawTxn: json.rawTxn,
        });
    }
}
exports.TradeCallParameters = TradeCallParameters;
